<style scoped>
.padding-left-6 {
  padding-left: 6px;
}
.padding-right-6 {
  padding-right: 6px;
}
</style>

<template>
  <div v-if="isItemSelected">
    <mu-tabs :value.sync="modelTab" center inverse>
      <mu-tab>
        <mu-icon value="picture_in_picture"></mu-icon>
        {{$t('overlay.tab.content')}}
      </mu-tab>
      <mu-tab>
        <mu-icon value="format_size"></mu-icon>
        {{$t('overlay.tab.style')}}
      </mu-tab>
    </mu-tabs>
    <mu-container v-if="modelTab === 0">
      <mu-form :model="form">
        <mu-form-item prop="input" :label="$t('overlay.text.content')" v-if="overlay.type == 'text'">
          <mu-text-field v-model="overlay.content" @change="onChangeOverlay" multi-line :rows="2"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="input" :label="$t('overlay.image.content')" v-else-if="overlay.type == 'img'">
          <mu-text-field v-model="overlay.src" disabled>
            <mu-button icon slot="append" @click="onClickUpload">
              <mu-icon value="attachment" />
            </mu-button>
          </mu-text-field>
        </mu-form-item>
      </mu-form>
    </mu-container>
    <mu-container v-if="modelTab === 1">
      <mu-form :model="form">
        <div v-if="overlay.type == 'text'">
          <mu-form-item prop="input" :label="$t('overlay.text.style.size')">
            <mu-text-field v-model="modelFontSize" type="number"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="input" :label="$t('overlay.text.style.padding')">
            <mu-text-field v-model="modelPadding" type="number"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="input" :label="$t('overlay.text.color.text')">
            <mu-text-field :value="stringColor(modelColor)" disabled>
              <mu-icon value="fiber_manual_record" slot="prepend" :color="'#' + stringColor(modelColor)" />
              <mu-button icon slot="append" @click="flagDialogColorText = true">
                <mu-icon value="settings" />
              </mu-button>
            </mu-text-field>
          </mu-form-item>
          <mu-form-item prop="input" :label="$t('overlay.text.color.background')">
            <mu-text-field :value="stringColor(modelBgColor)" disabled>
              <mu-icon value="fiber_manual_record" slot="prepend" :color="'#' + stringColor(modelBgColor)" />
              <mu-button icon slot="append" @click="flagDialogColorBackground = true">
                <mu-icon value="settings" />
              </mu-button>
            </mu-text-field>
          </mu-form-item>
        </div>
        <div v-else-if="overlay.type == 'img' && overlay.src">
          <mu-form-item prop="radio" :label="$t('overlay.image.style.size')">
            <mu-radio v-model="modelSize" value="seperate" :label="$t('overlay.image.style.seperate')"></mu-radio>
            <mu-radio v-model="modelSize" value="width" :label="$t('overlay.image.style.width')"></mu-radio>
            <mu-radio v-model="modelSize" value="height" :label="$t('overlay.image.style.height')"></mu-radio>
          </mu-form-item>
          <mu-row>
            <mu-col :span="overlay.size === 'seperate' ? 6 : 12" v-if="overlay.size !== 'height'">
              <mu-form-item prop="input" :label="$t('overlay.image.style.sizeX')">
                <mu-text-field v-model="modelSizeX" type="number"></mu-text-field>
              </mu-form-item>
              <mu-form-item prop="slider" class="padding-right-6">
                <mu-slider v-model="modelSizeX"></mu-slider>
              </mu-form-item>
            </mu-col>
            <mu-col :span="overlay.size === 'seperate' ? 6 : 12" v-if="overlay.size !== 'width'">
              <mu-form-item prop="input" :label="$t('overlay.image.style.sizeY')">
                <mu-text-field v-model="modelSizeY" type="number"></mu-text-field>
              </mu-form-item>
              <mu-form-item prop="slider" class="padding-left-6">
                <mu-slider v-model="modelSizeY"></mu-slider>
              </mu-form-item>
            </mu-col>
          </mu-row>
        </div>
      </mu-form>
    </mu-container>
    <mu-dialog :title="$t('overlay.text.color.text')" max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogColorText">
      <color-picker :value="modelColor" @input="onUpdateColor" />
      <mu-button slot="actions" flat color="primary" @click="flagDialogColorText = false"><mu-icon value="close"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('overlay.text.color.background')" max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogColorBackground">
      <color-picker :value="modelBgColor" @input="onUpdateBgColor" />
      <mu-button slot="actions" flat color="primary" @click="flagDialogColorBackground = false"><mu-icon value="close"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
    <mu-dialog :title="$t('overlay.image.upload')" max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogUpload">
      <mu-form :model="form">
      <mu-form-item prop="radio">
        <mu-radio v-model="modelType" value="invalid" disabled :label="$t('overlay.image.invalid')"></mu-radio>
        <mu-radio v-model="modelType" value="valid" disabled :label="$t('overlay.image.valid')"></mu-radio>
      </mu-form-item>
      <input type="file" id="file" ref="file" @change="onChangeFile" />
      </mu-form>
      <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
      <mu-button slot="actions" flat color="primary" @click="onActionUpload" :disabled="!isValidFile"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
    </mu-dialog>
  </div>
</template>

<script>

// Library
import { Chrome } from 'vue-color'
import axios from "axios";

// Utils
import timeFormatter from '@/utils/timeFormatter.js'

export default {
  name: 'OverlayEditor',
  components: {
    'color-picker': Chrome
  },
  props: {
    mediaId: {
      type: String,
      required: true
    },
    initData: {
      type: Object,
      required: true
    },
    initIndex: {
      type: Number,
      required: true
    },
    duration: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      overlay: this.initData,
      index: this.initIndex,

      flagDialogUpload: false,
      flagDialogColorText: false,
      flagDialogColorBackground: false,

      modelFile: "",
      modelFilename: "",
      modelType: "invalid",
      modelTab: 0,
      form: {}
    }
  },
  computed: {
    // Model
    modelX: {
      get() {
        if (this.overlay.xPos)
          return Math.round(this.overlay.xPos * 10000) / 10000;
        else
          return 0;
      },
      set(newValue) {
        if(newValue < 0)
          newValue = 0;
        if(newValue > 1)
          newValue = 1;
        this.overlay.xPos = newValue;
        this.onChangeOverlay();
      }
    },
    modelY: {
      get() {
        if (this.overlay.yPos)
          return Math.round(this.overlay.yPos * 10000) / 10000;
        else
          return 0;
      },
      set(newValue) {
        if(newValue < 0)
          newValue = 0;
        if(newValue > 1)
          newValue = 1;
        this.overlay.yPos = newValue;
        this.onChangeOverlay();
      }
    },
    modelFontSize: {
      get() {
        if (this.overlay.fontSize)
          return this.overlay.fontSize;
        else
          return 12;
      },
      set(newValue) {
        this.overlay.fontSize = Number(newValue);
        this.onChangeOverlay();
      }
    },
    modelPadding: {
      get() {
        if (this.overlay.padding)
          return this.overlay.padding;
        else
          return 0;
      },
      set(newValue) {
        this.overlay.padding = Number(newValue);
        this.onChangeOverlay();
      }
    },
    modelColor: {
      get() {
        if (this.overlay.color)
          return this.overlay.color;
        else
          return {
            r: 0,
            g: 0,
            b: 0,
            a: 1
          };
      },
      set(newValue) {
        this.overlay.color = newValue;
        this.onChangeOverlay();
      }
    },
    modelBgColor: {
      get() {
        if (this.overlay.backgroundColor)
          return this.overlay.backgroundColor;
        else
          return {
            r: 0,
            g: 0,
            b: 0,
            a: 0
          };
      },
      set(newValue) {
        this.overlay.backgroundColor = newValue;
        this.onChangeOverlay();
      }
    },
    modelRange: {
      get() {
        return [parseInt(this.overlay.start), parseInt(this.overlay.start) + parseInt(this.overlay.duration)];
      },
      set(newValue) {
        this.overlay.start = newValue[0];
        this.overlay.duration = newValue[1] - newValue[0];
        this.onChangeOverlay();
      }
    },
    modelSize: {
      get() {
        return this.overlay.size;
      },
      set(newValue) {
        this.overlay.size = newValue;
      }
    },
    modelSizeX: {
      get() {
        return Math.floor(this.overlay.sizeX * 100);
      },
      set(newValue) {
        this.overlay.sizeX = newValue / 100;
        this.onChangeOverlay();
      }
    },
    modelSizeY: {
      get() {
        return Math.floor(this.overlay.sizeY * 100);
      },
      set(newValue) {
        this.overlay.sizeY = newValue / 100;
        this.onChangeOverlay();
      }
    },
    modelStart: {
      get() {
        var sec_num = parseInt(this.overlay.start, 10);
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);
        return new Date(2000, 1, 1, hours, minutes, seconds);
      },
      set(newValue) {
        var hours = newValue.getHours();
        var minutes = newValue.getMinutes();
        var seconds = newValue.getSeconds();
        this.overlay.start = hours * 60 * 60 + minutes * 60 + seconds;
      }
    },
    modelEnd: {
      get() {
        var sec_num = parseInt(this.overlay.start + this.overlay.duration, 10);
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);
        return new Date(2000, 1, 1, hours, minutes, seconds);
      },
      set(newValue) {
        var hours = newValue.getHours();
        var minutes = newValue.getMinutes();
        var seconds = newValue.getSeconds();
        this.overlay.duration = hours * 60 * 60 + minutes * 60 + seconds - this.overlay.start;
      }
    },

    // String
    stringDuration() {
      return timeFormatter(this.duration);
    },

    // Flag
    isItemSelected() {
      return this.initIndex !== -1;
    },
    isValidFile() {
      if (this.modelType === "valid") {
        return true;
      } else {
        return false;
      }
    },
    isVideoReady() {
      if(this.duration === 0)
        return false;
      else
        return true;
    },
  },
  watch: {
    initData() {
      this.overlay = this.initData;
      this.modelTab = 0;
    },
    initIndex() {
      this.index = this.initIndex;
      this.modelTab = 0
    },
    modelStart() {
      this.$emit('onUpdateSlider', this.overlay.start);
    },
    modelEnd() {
      this.$emit('onUpdateSlider', this.overlay.start + this.overlay.duration);
    },
  },
  methods: {
    // Event
    onClickUpload() {
      this.modelFile = "";
      this.modelFilename = "";
      this.modelType = "invalid";
      this.flagDialogUpload = true;
    },
    onActionCancel() {
      this.modelFile = "";
      this.modelFilename = "";
      this.modelType = "invalid";
      this.flagDialogUpload = false;
    },
    onChangeOverlay() {
      this.$emit('onUpdateOverlay', {
        overlay: this.overlay,
        index: this.index
      });
    },
    onUpdateColor(color) {
      this.overlay.color = color.rgba;
      this.onChangeOverlay();
    },
    onUpdateBgColor(color) {
      this.overlay.backgroundColor = color.rgba;
      this.onChangeOverlay();
    },
    onChangeFile() {
      if (this.$refs.file.files[0] != undefined) {
        var type = this.$refs.file.files[0].type;
        if (type === "image/jpeg" || type === "image/png") {
          this.modelType = "valid";
          this.modelFile = this.$refs.file.files[0];
          this.modelFilename = this.$refs.file.files[0].name;
        } else {
          this.modelType = "invalid";
          this.modelFile = ""
          this.modelFilename = "";
        }
      } else {
        this.modelType = "invalid";
        this.modelFile = ""
        this.modelFilename = "";
      }
    },
    onActionUpload() {
      this.flagDialogUpload = false;
      let formData = new FormData();
      formData.append('_method', "PUT");
      formData.append('file', this.modelFile);
      formData.append('filename', this.modelFilename);
      axios.post(this.$store.getters.urlApi + "overlay/" + this.overlay._id, formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(response => {
        this.overlay.src = this.modelFilename;
        this.overlay.width = response.data.data.width;
        this.overlay.height = response.data.data.height;
      });
    },

    // String
    stringSizeFormatter(value) {
      return value + "%";
    },
    stringTimeFormatter(sec) {
      var sec_num = parseInt(sec, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      if(hours <= 0) {
        return minutes + ':' + seconds;
      } else {
        return hours + ':' + minutes + ':' + seconds;
      }
    },
    stringColor(color) {
      var red = this.rgbToHex(color.r);
      var green = this.rgbToHex(color.g);
      var blue = this.rgbToHex(color.b);
      return red+green+blue;
    },
    rgbToHex: function (rgb) {
      var hex = Number(rgb).toString(16);
      if (hex.length < 2) {
         hex = "0" + hex;
      }
      return hex.toUpperCase();
    },
  },
}
</script>
